import type { FaireProductEntity } from "../../entity_types/product";

export const p_4a23rkzrf2: FaireProductEntity = {
  token: "p_4a23rkzrf2",
  type: "product",
  name: "PATCHWORK MINI DRESS",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/3b25d6deac4fc1d4409bf8dab878b7e7fb9e3c1a34f940ab7b1d544e89332248.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/10e88b803a5047f83ecde829d7f6cf0ffbb83b75785b5d484714277ea44cde83.jpeg",
    "https://cdn.faire.com/fastly/72518f2c747099a015985c1f237e8b65cdde0c9ba40faabf6cf686c87680267f.jpeg",
    "https://cdn.faire.com/fastly/6b27ce26038204b31dd9352c240c5c2afd06eb6f88c6aa645f420ee1bb184b92.jpeg",
    "https://cdn.faire.com/fastly/2a05b28c23552c4c55c5426afa641a3549a22e236ea4e4e65443713fc46b98a3.jpeg",
  ],
  priceDollars: 144,
  description:
    'Model is wearing a size small.\n\n𝐌𝐨𝐝𝐞𝐥 𝐬𝐩𝐞𝐜𝐬\n• Height: 5\'8"\n• Bust: 32B\n• Waist: 24"\n• Hips: 34"',
  tags: [],
  msrpDollars: 288,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:14.683Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
